module.exports = __webpack_public_path__ + "f9a2a870be78531dcde445f3b1acfd09.svg";